import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import {
  CssBaseline,
  MuiThemeProvider,
  StylesProvider,
} from '@material-ui/core';
import { GlobalStyles } from './GlobalStyles';
import applyTheme from './applyTheme';

function StylesWrapper({ children }) {
  const fullTheme = useMemo(() => applyTheme(), []);
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={fullTheme}>
        <MuiThemeProvider theme={fullTheme}>
          <GlobalStyles />
          <CssBaseline />
          {children}
        </MuiThemeProvider>
      </ThemeProvider>
    </StylesProvider>
  );
}

StylesWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StylesWrapper;
